import { createIcon } from '../utils';

export const ActivityHeartFilledIcon = createIcon(
  ({ ref, className, innerClassName, width, height, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9.99462 4.27985C8.32849 2.332 5.55011 1.80804 3.46257 3.59168C1.37503 5.37532 1.08113 8.35748 2.72049 10.467C3.95873 12.0604 7.4764 15.2591 9.12367 16.7291C9.42648 16.9993 9.57789 17.1344 9.75518 17.1876C9.9091 17.2338 10.0801 17.2338 10.2341 17.1876C10.4113 17.1344 10.5628 16.9993 10.8656 16.7291C12.5128 15.2591 16.0305 12.0604 17.2687 10.467C18.9081 8.35748 18.6501 5.35656 16.5267 3.59168C14.4032 1.8268 11.6607 2.332 9.99462 4.27985Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.917 9.58333H12.0837L10.8337 12.0833L9.16699 7.08333L7.91699 9.58333H7.08366"
        className={innerClassName ?? 'stroke-primary-foreground'}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  {
    displayName: 'ActivityHeartFilledIcon',
    classNameBase: 'fill-current',
  },
);
